interface Props {
  value: number;
  max?: number;
  label: string;
  sublabel?: string;
  color?: string;
}

export function Donut({ value, max = 100, label, sublabel, color = "#0ea5e9" }: Props) {
  const pct = Math.min(100, Math.max(0, (value / max) * 100));
  const r = 36;
  const c = 2 * Math.PI * r;
  const offset = c - (pct / 100) * c;

  return (
    <div className="flex items-center justify-center">
      <div className="relative" style={{ width: 120, height: 120 }}>
        <svg viewBox="0 0 100 100" className="w-full h-full -rotate-90">
          <circle cx={50} cy={50} r={r} stroke="#e2e8f0" strokeWidth={10} fill="none" />
          <circle
            cx={50}
            cy={50}
            r={r}
            stroke={color}
            strokeWidth={10}
            fill="none"
            strokeDasharray={c}
            strokeDashoffset={offset}
            strokeLinecap="round"
            style={{ transition: "stroke-dashoffset .5s ease" }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="text-2xl font-bold">{pct.toFixed(1)}%</div>
          {sublabel && <div className="text-xs text-slate-500">{sublabel}</div>}
        </div>
      </div>
      <div className="ml-4 text-sm text-slate-600">{label}</div>
    </div>
  );
}
